import { getUserEmail, getUserName, isAuthDisabled } from '../auth/auth';
import { canAdmin, canSystemAdmin } from '../auth/permissions';
import '../styles/header.css';

function getDefaultRightLinks() {
  const hasAnyAdmin = canSystemAdmin() || canAdmin('ダッシュボード') || canAdmin('Life') || canAdmin('AWS利用料');
  if (hasAnyAdmin) {
    return [{ label: 'Master', href: '/master' }];
  }
  return [];
}

function UserBadge() {
  const email = getUserEmail();
  const name = getUserName();
  if (isAuthDisabled() || !email) return null;
  const displayName = name || email;
  const initial = displayName.charAt(0).toUpperCase();
  return (
    <div className="header-user-badge" title={email}>
      <span className="header-user-avatar">{initial}</span>
      <span className="header-user-email">{displayName}</span>
    </div>
  );
}

export default function Header({
  variant = 'landing',
  sectionLabel = '',
  primaryTabs = [],
  primaryTabActiveIndex = null,
  rightLinks = getDefaultRightLinks(),
  renderPrimaryTabs,
}) {
  const headerClassName = variant === 'compact' ? 'landing-header header--compact' : 'landing-header';
  const logoClassName = variant === 'compact' ? 'landing-logo header-logo--compact' : 'landing-logo';
  const navClassName = variant === 'compact' ? 'landing-nav header-nav--compact' : 'landing-nav';
  const linkClassName = variant === 'compact' ? 'landing-nav-link header-link--compact' : 'landing-nav-link';
  const showPrimaryTabs = Number.isInteger(primaryTabActiveIndex) && primaryTabs.length > 0;
  const showSectionLabel = Boolean(sectionLabel);
  const showRightLinks = Array.isArray(rightLinks) && rightLinks.length > 0;

  return (
    <header className={headerClassName} data-node-id="136:25">
      <div className="header-main-left">
        <h1 className={logoClassName} data-node-id="136:26">
          <a className="landing-logo-link" href="/">Mobibi</a>
        </h1>
        {showSectionLabel && (
          <p className="header-section-label">{sectionLabel}</p>
        )}
        {showPrimaryTabs && renderPrimaryTabs && renderPrimaryTabs({ primaryTabs, primaryTabActiveIndex })}
      </div>
      <div className="header-main-right">
        {showRightLinks && (
          <nav className={navClassName} data-node-id="136:27">
            {rightLinks.map((link) => (
              <a className={linkClassName} href={link.href} key={link.label}>
                {link.label}
              </a>
            ))}
          </nav>
        )}
        <UserBadge />
      </div>
    </header>
  );
}
